import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";

import {getData} from '../../../services/index';
import { Tabs ,Modal} from 'antd';
import { StickyContainer, Sticky } from 'react-sticky';
import 'antd/dist/antd.css';
import { message,Menu } from 'antd';
import { MailOutlined, AppstoreOutlined, SettingOutlined,DeleteOutlined } from '@ant-design/icons';

import { PlusOutlined,MoreOutlined,FieldTimeOutlined,EditOutlined } from '@ant-design/icons';


import next from '../../../assets/images/icon/next.png';
import add from '../../../assets/images/icon/add.png';

const { SubMenu } = Menu;
const { TabPane } = Tabs;

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			visible: false,
			category_list: [],
		}

	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
			}
		this.checkData()
	}


	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var app = {school_id : school_id,user_id:user_id}
			getData('Transport/assign_route_driver_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							category_list: result['data'],
						});
					}else{
						this.setState({
							category_list: [],
						});
					}
				}
			});



	}
  }

	showModal = () => {
		this.setState({
		  visible: true,
		});
	  };

	  handleOk = () => {
		this.setState({ loading: true });
		setTimeout(() => {
		  this.setState({ loading: false, visible: false });
		}, 3000);
	  };

	  handleCancel = () => {
		this.setState({ visible: false });
	  };



	showMenu= (id, e) =>  {
		e.preventDefault();
		if(this.state.showMenu == 1){
			document.getElementById('open_action_' + id).classList.remove('is-active');
			this.setState({
			  showMenu: 0,
			});
		}else{
			document.getElementById('open_action_' + id).classList.add('is-active');
			this.setState({
			  showMenu: 1,
			});
		}


	}

	handledelete=(e)=>{
		var app = {
			user_id : this.state.user_id,
			school_id : this.state.school_id,
			id : e,
		}
		getData('Transport/assign_route_driver_delete',app).then((result) => {
			if(result.status==200){
				message.config({ top: 150});
				message.success('Deleted Successfull',2);
				setTimeout(() => {
					this.checkData()
				}, 30);
			}
		});
	}

	render() {
	var lenght = this.state.category_list.length;
	const { current } = this.state;
	const { visible, loading } = this.state;
		return (
		<>


		<div class="row bred">
			<div class="col-md-12">
				<div class="card">
					<div class="card-body">
						<h4 class="page-title">
							<i class="mdi mdi-apple-keyboard-command title_icon"></i>Assign Route & Driver
							<Link to={`${process.env.PUBLIC_URL}/transport-setup/assign-route-driver-add`} className="btn btn-outline-primary btn-rounded alignToTitle"><i class="mdi mdi-plus"></i> Add Assign Route & Driver
							</Link>
							<div class="breadcrumb-wrapper">
								<ol class="breadcrumb">
									<li class="breadcrumb-item">
										<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
										<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
										</a>
									</li>
									<li class="breadcrumb-item">Assign Route & Driver</li>
								</ol>
							</div>
						</h4>
					</div>
				</div>
			</div>
		</div>


		<div class="row">
			<div class="card-body">
				<ul class="nav nav-tabs nav-tabs-solid">
					<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/transport-setup/drivers`} class="nav-link ">Driver Profile</Link></li>
					<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/transport-setup/manage-bus`} class="nav-link ">Manage Bus</Link></li>
					<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/transport-setup/manage-route/stop`} class="nav-link " >Manage Route</Link></li>
					<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/transport-setup/assign-route-driver`} class="nav-link active">Assign Route & Driver</Link></li>
					<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/transport-setup/manage-student`} class="nav-link">Assign Student</Link></li>
					<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/transport-setup/check-route`} class="nav-link">Route Details</Link></li>
							<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/transport-setup/ongoing-route`} class="nav-link">Ongoing Route</Link></li>
					<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/transport-setup/bus-on-map`} class="nav-link">Bus On Map</Link></li>
				</ul>
			</div>
		</div>


		<div class="">
		  <div class="row">
			 <div class="col-lg-12 mb-3">
			 <div class="card">
				<div class="card-body">
				<h4 class="mb-3 header-title">Assign Route & Driver</h4>
				<div class="table-responsive">
				   <table class="table table-striped table-bordered table-hover">
					  <thead>
						 <tr>
							<th>#</th>
							<th>Academic Year</th>
							<th>Bus Name</th>
							<th>Route Assign</th>
							<th>Driver Assign</th>
							<th>Action</th>
						 </tr>
					  </thead>
					  <tbody>
					  {this.state.category_list.length == 0 && (<><tr><td colspan="6" class="text-center">No Children Profile Found</td></tr></>)}
					  {this.state.category_list.map((list,index) => (
						 <tr>
							<td>{index+1}</td>
							<td>{list.academic_year}</td>
							<td>{list.bus_name}</td>
							<td>{list.route_name}</td>
							<td>{list.driver_name}</td>
							<td>
								<div class="dropright dropright">
									<button type="button" class="btn btn-sm btn-outline-primary btn-rounded btn-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
										<i class="mdi mdi-dots-vertical"></i>
									</button>
									<ul class="dropdown-menu">
										<li><Link to={`${process.env.PUBLIC_URL}/transport-setup/assign-route-driver-edit/${list.id}`} class="dropdown-item"><EditOutlined /> Edit</Link></li>
										<li><a href="javascript:void(0)" onClick={this.handledelete.bind(this,list.id)} class="dropdown-item"><EditOutlined />Delete</a></li>
									</ul>
								</div>
							</td>
						 </tr>
						 ))}

					  </tbody>
				   </table>
				</div>
				</div>
				</div>
			 </div>
		  </div>
		</div>


        </>
		)
	}
}
export default Index;
